"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
var serviceURL = "/platformservice/v1/api";
var config = {
  organization: serviceURL + "/organization",
  platformKey: serviceURL + "/platform/key",
  platform: serviceURL + "/platform",
  account: serviceURL + "/account",
  broadcast: serviceURL + "/broadcast",
  brand: serviceURL + "/platform/brand",
  palette: serviceURL + "/palette",
  templateContents: serviceURL + "/templates/contents",
  systemInfo: serviceURL + "/system",
  standardTemplate: serviceURL + "/standard/template",
  standardTemplatePrintBridge: serviceURL + "/standard/template/print/bridge",
  accessCriteriaForReportData: serviceURL + "/report/data/access-criteria",
  accountBulk: serviceURL + "/account/bulk",
  efsFileChecker: serviceURL + "/efsfile",
  crmImport: "/importservice/v1/api/import",
  crmExport: "/exportservice/v1/api/export/crm",
  crm: serviceURL + "/crm",
  crmFieldMapping: serviceURL + "/crm-field/mapping"
};
exports.config = config;